import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { AppConfig, ExcelService, PreviousRouteService, ParameterData, DataService } from '../../../_helpers/index';
import { CustomerService, DebtorService, InvoicesService, BackFilterService, DebtorDataService, ExcelDateConvertService, PayoutService, UserService } from '../../../_services';
import { AuthService } from '../../../_services/auth.service';

import { Status, Overduedate, ExpirationRank, Creation } from '../../../_enums/invoice';
import { BatchProcessUrls } from '../../../_enums/urls';
import { Invoice, InvoiceReportExport, QueryParamsList } from '../../../_models';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css', '../../../../assets/css/customer-list-table.css']
})
export class CollectInvoiceListComponent implements OnInit, OnDestroy, AfterViewInit {

  public customer_public_id: string;

  excelExportData: any;
  totalSize: any;
  excelExportDataNew: any;
  ddlStatus: any[];
  ddlExpirationPRank: any[];
  ddlExpirationRank: any[];
  ddlCreation: any[];

  public pageStartDate: any;
  public pageEndDate: any;


  public gmtZeroID = false;
  public gmtNonZeroID = false;

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  searchExpirationFilterForm: FormGroup;
  searchOverdueFilterForm: FormGroup;
  displayedColumns: string[] = [];
  dataSourceInvoicesList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  isExpirationVisiable = false;
  isOverdueVisiable = false;
  isRangoStatus = "None";
  auth0Profile: any;
  isLoading = true;
  pageSize: any;
  pageIndex: number = 0;
  pageStart: number = 0;
  PageSizeOptions: number[];
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  searchValue: any;
  isadmin = false;
  anularDis = false;
  isImport = false;
  tempInvoiceStatus: any;
  userDetails: any;
  userRole: any;
  userRoleStatus: any;
  isExportExcelAvailable = true;
  isImportAvailable = false;
  isCreateAvailable = false;
  isUpdateAvailable = true;
  isDeleteAvailable = true;
  isRejectAvailable = true;
  isReadAvailable = true;
  kashioApplication: any;
  invoiceRejectForm: FormGroup;
  rejectInvoiceId: any;
  paymentCodeConfiguration: any;
  isPaymentCodeConfiguration = false;
  statusDropdownValue = 0;
  creationDropdownValue = 3;
  statusFormControl = new FormControl(0);
  creationFormControl = new FormControl(3);
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  queryParams: QueryParamsList = {};
  snapshotQueryParam: QueryParamsList = {};
  startDateFromSnapshotQueryParam: boolean = false;
  endDateFromSnapshotQueryParam: boolean = false;

  baseURL: string;
  timerId: any;
  isExportDataAvailable: undefined | InvoiceReportExport;
  isErrorExportAvailable: object | undefined;
  timeCompleted: boolean = false;
  exportSubscription$ : Subscription;
  configurationDetails: any;

  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder
      , private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService, private debtorService: DebtorService
      , private invoicesService: InvoicesService
      , private creation: Creation
      , private expirationRank: ExpirationRank
      , private overduedate: Overduedate
      , private status: Status
      , private datePipe: DatePipe
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private titleService: Title
      , private payoutService: PayoutService
      , private userService: UserService
      , private debtorDataService:DebtorDataService
      , private backFilterService:BackFilterService
      , private previousRouteService:PreviousRouteService
      , private currencyPipe: CurrencyPipe
      , private excelDateConvertService:ExcelDateConvertService
      , private activatedRoute: ActivatedRoute
    ) {
      this.spinnerService.show();
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    this.ddlCreation = this.creation._creation;
    this.ddlExpirationRank = this.expirationRank._expirationRank;
    this.ddlExpirationPRank = this.overduedate._overduedate;

    this.ddlStatus = status._status;

    this.isRangoVisiable = false;
    this.isExpirationVisiable = false;
    this.isOverdueVisiable = false;
    this.isadmin = false;
    this.isImport = false;
    //this is used to get the customer key comes from service; if public key is empty then default key will be asigned.
    this.dataService.currentPublicKey.subscribe((data) => {
      this.customerPublic_key = data;
    });
    this.InitialSetup();
    this.backFilterService.getInvoiceSearchSharedData().subscribe(data => this.backToSearchSharedData = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
    this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V1;
  }//end 

  InitialSetup() {
    this.invoiceRejectForm = this._fb.group({
      description: new FormControl('',[Validators.required]),
    })
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceInvoicesList.data.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  removeSelectedRows() {
    this.selection.selected.forEach(item => {
      this.invoicesService.deleteInvoice(item.public_id).subscribe(data => {
        this.getInvoiceList()
      },
        error => {

          console.log('Failed! while trying to the invoices delete. ' + error.error);
        });
      this.anularDis = false;
    });
    this.selection = new SelectionModel<Element>(true, []);
  }



  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceInvoicesList.data.forEach(row => this.selection.select(row));
  }


  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.searchValue = this.filterValue.toLowerCase().trim();
    this.GetCustomerInvoicesListFilterAndSearch();
  }//end

  ngOnInit() {


    this.checkThisPageGrants();
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    let browserStorageAdmin = localStorage.getItem('isadmin');

    if (browserStorage1 == null) {
      this.isImport = false;
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');


      }


      if (browserStorageAdmin == 'true') {

        this.isadmin = true;
      }
      else {

        this.isadmin = false;
      }
    }
    else {

      this.isImport = true;
      this.customer_public_id = localStorage.getItem('subcompanyId');


      if (browserStorageAdmin == 'true') {

        this.isadmin = true;
      }
      else {

        this.isadmin = false;
      }
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;


    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {

      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;

      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;


    }
    this.kashioApplication = localStorage.getItem('application');

    this.tempInvoiceStatus = 'all';
    this.pageStartDate = this.setTodayValueFilter('00:00:00');
    this.pageEndDate = this.setTodayValueFilter('23:59:59');
    this.searchValue = '';
    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.searchExpirationFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.searchOverdueFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    if (this.creation._creation.length > 8) {
      this.creation._creation.shift();
    }

    if (this.expirationRank._expirationRank.length > 6) {
      this.expirationRank._expirationRank.shift();
    }

    if (this.overduedate._overduedate.length > 9) {
      this.overduedate._overduedate.shift();
    }
    //back to search start
    this.previousUrl = this.previousRouteService.getPreviousUrl();
    if ((this.isBrowserBackButtonPressed == true) &&
      (this.previousUrl.includes("/collect/invoices/") || this.previousUrl.includes("/customers/")) &&
      (this.previousUrl.includes("/edit") || this.previousUrl.includes("/view"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    }else{
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setInvoiceSearchSharedData(null);
    }
    //back to search end

    this.searchFilterForm = this.formBuilder.group({
      searchText: [this.searchValue, Validators.required]
    });

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    if (this.kashioApplication == "PAYMENTS") {
      this.checkPaymentCodeConfiguration().then(res => this.GetCustomerInvoicesList());
    }
    else{
      this.GetCustomerInvoicesList();
    }
    
  }//end

  setBackToSearchData(){
    if (this.backToSearchSharedData != null) {
      this.searchValue = this.backToSearchSharedData.search;
      this.tempInvoiceStatus = this.backToSearchSharedData.status;
      this.statusFormControl.setValue(this.backToSearchSharedData.statusDropdownValue);
      this.creationFormControl.setValue(this.backToSearchSharedData.creationDropdownValue);
      this.statusDropdownValue = this.backToSearchSharedData.statusDropdownValue;
      this.creationDropdownValue = this.backToSearchSharedData.creationDropdownValue;
      this.pageSize = this.backToSearchSharedData.pageSize;
      this.pageIndex = this.backToSearchSharedData.pageIndex;
      this.pageStart = this.backToSearchSharedData.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      if (this.backToSearchSharedData.creationDropdownValue == 8) {
        this.searchRangoFilterForm = this._fb.group({
          searchFromDate: [this.backToSearchSharedData.searchFromDate],
          searchToDate: [this.backToSearchSharedData.searchToDate]
        });
        this.isRangoStatus = this.backToSearchSharedData.rangoStatus;
        this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
        this.ddlCreation.unshift({ value: 8, name: this.filterValue });
        this.isRangoVisiable = false;
        this.pageStartDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
        this.pageEndDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
        this.creationFormControl.setValue(8);
        this.creationDropdownValue = 8;
      }else {
        this.pageStartDate = this.backToSearchSharedData.creationStartDate;
        this.pageEndDate = this.backToSearchSharedData.creationEndDate;
      }
      this.setBackToSearchFilter();
    }
  }

  invoiceListColumnsdisplay(){
    if(this.kashioApplication == "PAYOUTS"){
      this.displayedColumns = ['select', 'created','due_datetime', 'metadata.order_description', 'debtor.name', 'total.value', 'status', 'actions'];
    }
    else if(this.kashioApplication == "PAYMENTS"){
      if(this.isPaymentCodeConfiguration == true){
        this.displayedColumns = ['select', 'created','due_datetime', 'ktin','metadata.order_description', 'debtor.name', 'total.value', 'status', 'actions'];
      }else{
        this.displayedColumns = ['select', 'created','due_datetime','metadata.order_description', 'debtor.name', 'total.value', 'status', 'actions'];
      }
    }
    else{
      this.displayedColumns = ['select', 'created', 'due_datetime', 'metadata.order_description', 'debtor.name', 'total.value', 'status', 'actions'];
    }
  }

  ngOnDestroy() {
  }

  GetCustomerInvoicesList() {
    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length != 0) {

      let creationStateInvoiceList = JSON.parse(localStorage.getItem('creationStateInvoiceList'));
      let customCreationInvoiceRange = localStorage.getItem('customCreationInvoiceRange');

      if (this.snapshotQueryParam["pageIndex"] != undefined) {
        if(this.snapshotQueryParam["pageIndex"] != ''){
          this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
        } else {
          this.queryParams.pageIndex = this.pageIndex.toString();
        }
      };

      if (this.snapshotQueryParam["pageSize"] != undefined) {
        if(this.snapshotQueryParam["pageSize"] != '') {
          this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
        } else {
          this.queryParams.pageSize = this.pageSize.toString();
        }
      };

      if(this.snapshotQueryParam["startDate"] != undefined || this.snapshotQueryParam["endDate"] != undefined) {
        if(this.snapshotQueryParam["startDate"] != '') {
          this.startDateFromSnapshotQueryParam = true;
          this.queryParams.startDate = this.snapshotQueryParam["startDate"].replace(' ', '-');
        } else {
          this.queryParams.startDate = this.pageStartDate;
        }

        if(this.snapshotQueryParam["endDate"] != '') {
          this.endDateFromSnapshotQueryParam = true;
          this.queryParams.endDate = this.snapshotQueryParam["endDate"].replace(' ', '-');
        } else {
          this.queryParams.endDate = this.pageEndDate;
        }
        
        if (creationStateInvoiceList === 8) {
          this.creationFormControl.setValue(8); 
          this.ddlCreation.unshift({ value: 8, name: customCreationInvoiceRange });
        } else {
          this.creationFormControl.setValue(creationStateInvoiceList);
        };
      };

      if (this.snapshotQueryParam["status"] != undefined) {
        this.queryParams.status = this.snapshotQueryParam["status"];
        this.setStatusFormBySnapshotQueryParam(this.queryParams.status);
      };

      if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] != '') {
        this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
        this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
      };

      this.pageEvent(this.queryParams);
    } else {
      localStorage.setItem('creationStateInvoiceList', '3');
      this.invoicesService.getInvoiceList(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate, this.pageEndDate, this.pageSize, this.pageStart, this.searchValue).subscribe(data => {
        this.invoiceListColumnsdisplay();
        let resources = data["data"];
        this.isLoading = false;
        this.totalSize = JSON.parse(data.records);
        this.dataSourceInvoicesList.data = resources;
        this.spinnerService.hide();
      },
        error => {
          this.isLoading = false;
          console.log('Failed! while trying to get the invoices list. ' + error.error);
        });
    }
  }//end

  pageEvent(event: Params) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    if(event["startDate"]){
      if(this.startDateFromSnapshotQueryParam == true) {
        this.queryParams.startDate = event["startDate"];
        this.pageStartDate = this.replaceAt(10, event["startDate"], ' ');
        this.startDateFromSnapshotQueryParam = false;
      } else {
        this.pageStartDate = event["startDate"];
        this.queryParams.startDate = event["startDate"].replace(' ', '-');        
      }
    } else {
      this.queryParams.startDate = this.pageStartDate;
      this.queryParams.startDate = this.queryParams.startDate.replace(' ', '-');
    };

    if(event["endDate"]){
      if(this.endDateFromSnapshotQueryParam == true) {
        this.queryParams.endDate = event["endDate"];
        this.pageEndDate = this.replaceAt(10, event["endDate"], ' ');
        this.endDateFromSnapshotQueryParam = false;
      } else {
        this.pageEndDate = event["endDate"];
        this.queryParams.endDate = event["endDate"].replace(' ', '-');      
      }
    } else {
      this.queryParams.endDate = this.pageEndDate;
      this.queryParams.endDate = this.queryParams.endDate.replace(' ', '-');
    };

    if(event["status"]){
      this.queryParams.status = event["status"];
      this.tempInvoiceStatus = this.queryParams.status;
    } else {
      this.queryParams.status = this.tempInvoiceStatus;
    };

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
      replaceUrl: true
    });

    this.invoicesService.getInvoiceList(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate, this.pageEndDate, this.pageSize, this.pageStart, this.searchValue).subscribe(data => {
      this.invoiceListColumnsdisplay();
      let resources = data["data"];
      this.isLoading = false;
      this.dataSourceInvoicesList.data = resources;
      this.totalSize = JSON.parse(data.records);
      this.selection.clear();
      this.spinnerService.hide();
    },
      error => {
        this.isLoading = false;
        console.log('Failed! while trying to get the invoices list. ' + error.error);
      });
    this.setBackToSearchFilter();

  }

  setStatusFormBySnapshotQueryParam(status) {
    switch (status) {
      case 'all':
        this.statusFormControl.setValue(0);
        break;
      case '(1)':
        this.statusFormControl.setValue(1);
        break;
      case '(3)':
        this.statusFormControl.setValue(2);
        break;
      case '(4)':
        this.statusFormControl.setValue(3);
        break;
      case '(5)':
        this.statusFormControl.setValue(4);
        break;
      case '(6)':
        this.statusFormControl.setValue(6);
        break;
      case '(8)':
        this.statusFormControl.setValue(5);
        break;
      case '(10)':
        this.statusFormControl.setValue(7);
        break;
      case '(11)':
        this.statusFormControl.setValue(8);
        break;
      default:
        this.statusFormControl.setValue(0);
    }
  }

  replaceAt(index, textToReplace, character) {
    let chars = textToReplace.split('');
    chars[index] = character;
    return chars.join('');
  }

  filterRangoDetails() {

    if (this.creation._creation.length > 8) {
      this.creation._creation.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
    localStorage.setItem('customCreationInvoiceRange', this.filterValue);
    this.ddlCreation.unshift({ value: 8, name: this.filterValue });

    this.isRangoVisiable = false;

    var CurrentmonthFirstDate1 = new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US'));
    let CurrentmonthFirstDate3 = this.convertGMTTime(CurrentmonthFirstDate1);

    var CurrentmonthEndDate1 = new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US'));
    let CurrentmonthEndDate3 = this.convertGMTTime(CurrentmonthEndDate1);

    this.pageStartDate = CurrentmonthFirstDate3;
    this.pageEndDate = CurrentmonthEndDate3;

    this.creationFormControl.setValue(8);
    this.creationDropdownValue = 8;
   
    this.GetCustomerInvoicesListFilterAndSearch();

  }//end

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit(){
    this.dataSourceInvoicesList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourceInvoicesList.sort = this.sort;
  }

  GetCustomerInvoicesListFilterAndSearch() {
    this.spinnerService.show();
    this.pageStart = 0;
    this.pageIndex = 0;
    this.setBackToSearchFilter();
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize =  this.pageSize;
    this.queryParams.startDate = this.pageStartDate;
    this.queryParams.endDate = this.pageEndDate;
    this.queryParams.status = this.tempInvoiceStatus;
    if (this.searchValue != '') {
      this.queryParams.textSearch = this.searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.pageEvent(this.queryParams);
  }

  filterStatusDetails(status) {
    this.statusDropdownValue = status;
    if (status == this.ddlStatus[0].value) {
      this.tempInvoiceStatus = 'all';
    }
    else if (status == this.ddlStatus[1].value) {
      this.tempInvoiceStatus = '(1)';
    }
    else if (status == this.ddlStatus[2].value) {
      this.tempInvoiceStatus = '(3)';
    }

    else if (status == this.ddlStatus[3].value) {
      this.tempInvoiceStatus = '(4)';
    }
    else if (status == this.ddlStatus[4].value) {
      this.tempInvoiceStatus = '(5)';
    }
    else if (status == this.ddlStatus[5].value) {
      this.tempInvoiceStatus = '(8)';
    }
    else if (status == this.ddlStatus[6].value) {
      this.tempInvoiceStatus = '(6)';
    }
    else if (status == this.ddlStatus[7].value) {
      this.tempInvoiceStatus = '(10)';
    }
    else if (status == this.ddlStatus[8].value) {
      this.tempInvoiceStatus = '(11)';
    }
    else if (this.ddlStatus[9] && status == this.ddlStatus[9].value) {
      this.tempInvoiceStatus = '(12)';
    }
    else if (this.ddlStatus[10] && status == this.ddlStatus[10].value) {
      this.tempInvoiceStatus = '(15)';
    }
    else if (this.ddlStatus[11] && status == this.ddlStatus[11].value) {
      this.tempInvoiceStatus = '(16)';
    }
    else if (this.ddlStatus[12] && status == this.ddlStatus[12].value) {
      this.tempInvoiceStatus = '(17)';
    }else{
      this.tempInvoiceStatus = '';
    }
    this.GetCustomerInvoicesListFilterAndSearch();
  }

  filterAllDetails() {
    localStorage.setItem('creationStateInvoiceList', '8');

    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
    ) {
      if (this.isRangoStatus == "Expired") {
        this.filterRangoExpDetails();
      }

      if (this.isRangoStatus == "Overdue") {
        this.filterRangoOverdueDetails();
      }

      if (this.isRangoStatus == "creation") {
        this.filterRangoDetails();
      }
    }
    else {
      localStorage.setItem('creationStateInvoiceList', '3');

      if (this.overduedate._overduedate.length > 9) {
        this.overduedate._overduedate.shift();
      }
      if (this.expirationRank._expirationRank.length > 6) {
        this.expirationRank._expirationRank.shift();
      }

      if (this.creation._creation.length > 8) {
        this.creation._creation.shift();
      }
      this.isRangoVisiable = false;

      this.creationFormControl.setValue(3);
      this.creationDropdownValue = 3;
      this.pageStartDate = this.setTodayValueFilter('00:00:00');
      this.pageEndDate = this.setTodayValueFilter('23:59:59');
      this.setBackToSearchFilter();

      this.GetCustomerInvoicesListFilterAndSearch();
    }

  }


  filterRangoExpDetails() {

    if (this.expirationRank._expirationRank.length > 6) {
      this.expirationRank._expirationRank.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
    localStorage.setItem('customCreationInvoiceRange', this.filterValue);
    this.ddlExpirationRank.unshift({ value: 6, name: this.filterValue });

    this.isExpirationVisiable = false;
    this.isRangoVisiable = false;


    this.dataSourceInvoicesList.filter = '';
    let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
    let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
    this.dataSourceInvoicesList.filterPredicate = (data: Invoice, filter: string) =>
      data.expiration_datetime >= CurrentmonthFirstDate && data.expiration_datetime <= CurrentmonthEndDate;

    this.dataSourceInvoicesList.filter = '2018-10-24 01:59:45';


  }//end


  filterRangoOverdueDetails() {

    if (this.overduedate._overduedate.length > 9) {
      this.overduedate._overduedate.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
    localStorage.setItem('customCreationInvoiceRange', this.filterValue);
    this.ddlExpirationPRank.unshift({ value: 9, name: this.filterValue });

    this.isOverdueVisiable = false;
    this.isRangoVisiable = false;

    this.dataSourceInvoicesList.filter = '';

    var CurrentmonthFirstDate1 = new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US'));
    let CurrentmonthFirstDate3 = this.convertGMTTime(CurrentmonthFirstDate1);

    var CurrentmonthEndDate1 = new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US'));
    let CurrentmonthEndDate3 = this.convertGMTTime(CurrentmonthEndDate1);

    this.pageStartDate = CurrentmonthFirstDate3;
    this.pageEndDate = CurrentmonthEndDate3;
    this.GetCustomerInvoicesListFilterAndSearch();

  }//end


  filterCreationDetails(creation) {
    this.creationDropdownValue = creation;
    if(creation != 7) {
      localStorage.setItem('creationStateInvoiceList', creation);
    };
    this.ddlCreation = [];
    this.ddlCreation = this.creation._creation;

    var currentDate = new Date();
    var currentDate1 = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekLastDate.getDate() - (currentweekLastDate.getDay() - 1) + 6);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

    // All Datas Condition
    if (creation == 0) {
      this.pageStartDate = '2017-01-01';
      this.pageEndDate = '2030-01-01';
      this.GetCustomerInvoicesListFilterAndSearch();
    }

    // Current Month Filter Condition
    if (creation == 1) {

      var CurrentmonthFirstDate1 = new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let CurrentmonthFirstDate = this.convertGMTTime(CurrentmonthFirstDate1);

      var CurrentmonthEndDate1 = new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let CurrentmonthEndDate = this.convertGMTTime(CurrentmonthEndDate1);

      this.pageStartDate = CurrentmonthFirstDate;
      this.pageEndDate = CurrentmonthEndDate;
      this.GetCustomerInvoicesListFilterAndSearch();

    }

    // Current Week Filter Condition
    if (creation == 2) {

      var WeekstartDate1 = new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let WeekstartDate = this.convertGMTTime(WeekstartDate1);

      var WeekendDate1 = new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let WeekendDate = this.convertGMTTime(WeekendDate1);

      this.pageStartDate = WeekstartDate;
      this.pageEndDate = WeekendDate;
      this.GetCustomerInvoicesListFilterAndSearch();
    }

    // Today Filter Condition
    if (creation == 3) {
      currentDate.setDate(currentDate.getDate());
      currentDate1.setDate(currentDate1.getDate());

      var todayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(todayStartDate);

      var todayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let endDate = this.convertGMTTime(todayEndDate);

      this.pageStartDate = startDate;
      this.pageEndDate = endDate;
      this.GetCustomerInvoicesListFilterAndSearch();

    }

    // Yesterday Filter Condition
    if (creation == 4) {
      currentDate.setDate(currentDate.getDate() - 1);
      currentDate1.setDate(currentDate1.getDate() - 1);


      var yesterdayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(yesterdayStartDate);

      var yesterdayEndDate = new Date(formatDate(currentDate1, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let endDate = this.convertGMTTime(yesterdayEndDate);

      this.pageStartDate = startDate;
      this.pageEndDate = endDate;
      this.GetCustomerInvoicesListFilterAndSearch();
    }


    // Last Week Filter Condition
    if (creation == 5) {

      var lastWeekstartDate1 = new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let lastWeekstartDate = this.convertGMTTime(lastWeekstartDate1);

      var lastWeekendDate1 = new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let lastWeekendDate = this.convertGMTTime(lastWeekendDate1);

      this.pageStartDate = lastWeekstartDate;
      this.pageEndDate = lastWeekendDate;
      this.GetCustomerInvoicesListFilterAndSearch();
    }

    // Last Month Filter Condition
    if (creation == 6) {

      var LastmonthFirstDate1 = new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let LastmonthFirstDate = this.convertGMTTime(LastmonthFirstDate1);

      var LastmonthEndDate1 = new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let LastmonthEndDate = this.convertGMTTime(LastmonthEndDate1);

      this.pageStartDate = LastmonthFirstDate;
      this.pageEndDate = LastmonthEndDate;
      this.GetCustomerInvoicesListFilterAndSearch();

    }


    // Range Filter Condition
    if (creation == 7) {
      this.isRangoStatus = "creation";
      this.isRangoVisiable = true;
    }

    if(creation == 8){
      this.filterAllDetails();
    }

    this.setBackToSearchFilter();
  }//end

  /****GMT Converstion */
  convertGMTTime(startDate1) {


    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }


  }

  invoicegridActionClick(viewtype, value) {
    var publicid = value.public_id;
    switch (viewtype) {
      case 'invoiceview':
        this.router.navigate([`/collect/invoices/${publicid}/view`]);
        break;
      case 'invoiceedit':
        this.router.navigate([`/collect/invoices/${publicid}/edit`]);
        break;

      case 'invoicedelete':
        this.onConfirmInvoice(publicid);

        break;

      case 'invoicedupicate':
        this.duplicateInvoiceDetails(publicid,value);
        break;

      case 'invoicereject':
        this.InitialSetup();
        this.rejectInvoiceId = publicid;
        //this.rejectInvoices(publicid);
        break;

      default:
        this.router.navigate([`/collect/invoices/${publicid}/view`]);

    }//end switch

  }

  duplicateInvoiceDetails(publicid,value) {

    this.parameterData.InvoiceIdParameters = publicid;
    var data = {
      fromPage: 'invoiceList',
      name: value.debtor.name,
      public_id: value.debtor.public_id
    };
    this.debtorDataService.setPreSelectDebtorSharedData(data);
    this.router.navigate(['/invoices/create']);
  }

  onConfirmInvoice(publicid) {
    this.spinnerService.show();
    this.invoicesService.deleteInvoice(publicid)
      .subscribe((result) => {
        this.getInvoiceList();
      }, error => {
        this.spinnerService.hide();
        console.log('Failed while trying to cancel the invoice Details.' + error);
      });
  } //end method

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == undefined && this.isErrorExportAvailable == undefined) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 11000);
  }

  reportExport() {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;

    this.checkResponseExportTime();
    this.exportSubscription$ = this.invoicesService.reportExport(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate, 
      this.pageEndDate, this.searchValue).subscribe(data => {
      this.isExportDataAvailable = data;
      if (data.storage_url != undefined) {
        location.href = data.storage_url;
      } else {
        console.log(data);
      }
      this.spinnerService.hide();
    }, err => {
      this.spinnerService.hide();
      this.isErrorExportAvailable = err;
      console.log('Failed while trying to export txt file.' + err.error);
    });
  }

  closeModal() {
    this.timeCompleted = false;
  };

  setExportExcelFileData(excelExportData) {

    var excelHeader = ["FECHA DE CREACION", "VENCIMIENTO", "EXPIRACION", "ID ORDEN DE PAGO", "DESCRIPCIÓN","NOMBRE CLIENTE", "MONEDA","SUBTOTAL", "MORA", "TOTAL", "ESTADO"]

    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      delete singleRec_temp['livemode'];

      delete singleRec_temp['object'];



      columnsKeyNames = Object.keys(singleRec_temp);

      var created_temp;
      var due_datetime_temp;
      var expiration_datetime_temp;
      var external_id_temp;
      var debtor_temp;
      var creditor_temp;
      var sub_total_temp;
      var late_fee_temp;
      var total_temp;
      var status_temp;
      var moneda_temp;


      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {
        if (columnsKeyNames[i] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "due_datetime") {
          due_datetime_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "expiration_datetime") {
          expiration_datetime_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "invoice_id") {
          external_id_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "name") {
          creditor_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "debtor") {
          debtor_temp = singleRec_temp[columnsKeyNames[i]].name;
        }



        if (columnsKeyNames[i] == "total") {
          total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");
          moneda_temp = singleRec_temp[columnsKeyNames[i]].currency;
        }

        if (columnsKeyNames[i] == "sub_total") {
          sub_total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");
        }


        if (columnsKeyNames[i] == "late_fee") {
          late_fee_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");
        }

        var statusEnglish;
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'NEW':
              status_temp = 'Pendiente'
              break;
            case 'PENDING':
              status_temp = 'Pendiente'
              break;
            case 'PROCESSING':
              status_temp = 'Pendiente'
              break;
            case 'PAID':
              status_temp = 'Pagado'
              break;
            case 'VOIDED':
              status_temp = 'Anulado'
              break;
            case 'EXPIRED':
              status_temp = 'Expirado'
              break;
            case 'VOIDED_CUSTOMER':
              status_temp = 'Anulado'
              break;
            case 'OVERDUE':
              status_temp = 'Vencido'
              break;
            case 'PAYMENT_ON_HOLD':
              status_temp = 'Pendiente'
              break;
            case 'REJECTED':
              status_temp = 'Rechazado'
              break;
            case 'REVERSED':
              status_temp = 'Revertido'
              break;
            default:
              status_temp = statusEnglish;

          }//end switch

        }
      }//end for


      arrFinalData.push([this.excelDateConvertService.convertExcelDateTime(created_temp), this.excelDateConvertService.convertExcelDateTime(due_datetime_temp), this.excelDateConvertService.convertExcelDateTime(expiration_datetime_temp),
        external_id_temp, creditor_temp, debtor_temp, moneda_temp, sub_total_temp, late_fee_temp, total_temp, status_temp]);

    }
    this.excelService.generateInvoicesExcelFile(excelHeader, arrFinalData, 'InvoiceList', localStorage.getItem('application'));
  }//end function

  getInvoiceList() {
    this.invoicesService.getInvoiceList(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue).subscribe(data => {
      let resources = data["data"];
      this.isLoading = false;
      this.paginator.pageIndex = 0;
      this.dataSourceInvoicesList.data = resources;
      this.spinnerService.hide();
    },
      error => {
        this.isLoading = false;
        console.log('Failed! while trying to get the invoices list. ' + error);
      });
  }

  rejectInvoice() {
    this.spinnerService.show();
    let rejectDescription = this.invoiceRejectForm.controls['description'].value;
    this.payoutService.rejectInvoice(this.rejectInvoiceId,rejectDescription).subscribe(result => {
      this.getInvoiceList();
    },
      error => {
        console.log('Failed while trying to reject the invoice Details.' + error);
      })
  }

  async getUserRoleStatus() {
    try {
        const data = await this.userService.getUserDetails(localStorage.getItem('userId'));
        this.userDetails = data;
        this.userRole = this.userDetails.role;
        this.userRoleStatus = this.userDetails.status;
    }
    catch (error) {
        console.log('Failed while trying to getUserRoleStatus.' + error)
    }
    
}
  async checkPaymentCodeConfiguration() {
    try {
      const data = await this.customerService.checkPaymentCodeConfiguration(this.customer_public_id);
      this.paymentCodeConfiguration = data;
      if (this.paymentCodeConfiguration.status == 'ACTIVE') {
        this.isPaymentCodeConfiguration = true;
      }
    }
    catch (error) {
      console.log('Failed while trying to get the payment code configuration.' + error.error)
    }
  }

  async checkThisPageGrants() {
    await this.getUserRoleStatus();
    await this.auth.isKashioGrantsAvailable();
    this.isExportExcelAvailable = this.auth.checkGrants('INVOICES', 'EXPORT');
    this.isImportAvailable = this.auth.checkGrants('INVOICES', 'IMPORT');
    this.isCreateAvailable = this.auth.checkGrants('INVOICES', 'CREATE');
    this.isUpdateAvailable = this.auth.checkGrants('INVOICES', 'UPDATE');
    this.isDeleteAvailable = this.auth.checkGrants('INVOICES', 'DELETE');
    this.isReadAvailable = this.auth.checkGrants('INVOICES', 'READ');
    if( localStorage.getItem('application') == 'PAYOUTS' && this.userRole == 'KashIO-OPS' && this.userRoleStatus == 'ACTIVE'){
      this.isRejectAvailable = this.auth.checkGrants('INVOICES', 'REJECT');
    }else {
      this.isRejectAvailable = false;
    }
  }

  setBackToSearchFilter(){
    this.tempSearch = {
      search: this.searchValue,
      creationStartDate: this.pageStartDate,
      creationEndDate: this.pageEndDate,
      status: this.tempInvoiceStatus,
      statusDropdownValue: this.statusDropdownValue,
      creationDropdownValue: this.creationDropdownValue,
      searchFromDate: this.searchRangoFilterForm.controls.searchFromDate.value,
      searchToDate: this.searchRangoFilterForm.controls.searchToDate.value,
      rangoStatus: this.isRangoStatus,
      pageSize: this.pageSize,
      pageIndex:this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setInvoiceSearchSharedData(this.tempSearch);
  }

  setTodayValueFilter(hour: string) {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    var todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }
}
